 <template>
  <div
    :class="[
      'fourPage',
      pageFourAction ? 'animated pageFadeIn' : 'pageFadeOut',
    ]"
  >
    <div
      :class="[
        'fourIconPng',
        fourTitShow ? 'imgAnimated  imgFadeIn' : 'bgGray',
      ]"
    ></div>
    <!-- 白底 + 边框  文字-->
    <div
      :class="['titHeader',   'fourAnimated']"
      v-if="fourTitShow"
    >
      围绕经营抓党建，<br />抓好党建促发展
      <span class="circle circleOne"></span>
      <span class="circle"></span>
    </div>
    <div class="titBox">
      <!-- <h4 class="tit fourAnimated fadeInDownBig" v-if="fourTitShow">
        围绕经营抓党建、抓好党建促发展
      </h4> -->
      <p class="textMian animated delay fadeIn" v-if="fourTitShow">
       2019年5月16日，中共合肥高新技术产业开发区天乐社区服务中心委员会，同意成立中共东华（安徽）生态规划院有限公司支部委员会。自党支部成立以来我院高度重视并多次组织各类党建活动，用实践行动发扬党的精神，提升团队的凝聚力和战斗力。
      </p>
    </div>
    <div class="bwBox" v-if="fourBtnShow" @click="changeHue">
      <div class="wave wave4"></div>
      <div class="wave wave3"></div>
      <div class="wave wave1"></div>
      <div class="wave waveOne">
        <!-- <img :src="baseUrl + 'img/dhShare/dianFour.png'" class="textAmation" /> -->
        <img :src="baseUrl + 'img/dhShare/dianIcon.png'" class="textAmation" />
      </div>
    </div>
    <div :class="['imgMainBox', fourTitShow ? 'imgMainBoxShow' : '']">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperChild">
        <swiper-slide
          class="slideItem"
          v-for="(item, index) in slideList"
          :key="index"
        >
          <van-image
            fit="cover"
            @click="seeImg(item, index)"
            :src="baseUrl + item.imgUrl"
          />
        </swiper-slide>
      </swiper>
    </div>

    <van-overlay @click="bigImgShow = false" class="tkMain" :show="bigImgShow">
      <div class="wrapper">
        <van-image
          fit="cover"
          :src="baseUrl + bigImgUrl + '?x-oss-process=image/resize,p_50'"
        />
      </div>
    </van-overlay>
  </div>
</template>
<script>
import "@/assets/style/animate.min.less";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "@/assets/style/animate.min.less";
export default {
  name: "fourPage",
  props: {
    landscapeType: {
      type: Boolean,
      default: false,
    },
    newIndex: {
      type: String,
    },
  },
    components: {
    swiper,
    swiperSlide,
  },

  data() {
    return {
      baseUrl: process.env.BASE_URL,
      typePage: false,
      fourTitShow: false,
      pageFourAction: false,
      fourBtnShow: true,
      bigImgShow: false,
      swiperOption: {
        loop: false,
        slidesPerView: 3, //数量
        spaceBetween: 15, //间距
        initialSlide: 1,
        centeredSlides: true,
        direction: "horizontal", //设置水平horizontal还是垂直vertical
      },
      bigImgUrl: "",
      slideList: [
        {
          imgUrl: "img/dhShare/fourK001.jpg",
        },
        {
          imgUrl: "img/dhShare/fourK002.jpg",
        },
        {
          imgUrl: "img/dhShare/fourK003.jpg",
        },
        {
          imgUrl: "img/dhShare/fourK004.jpg",
        },
        {
          imgUrl: "img/dhShare/fourK005.jpg",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.typePage = this.landscapeType;
      this.initPage();
    });
  },
  methods: {
    initPage() {
      this.pageFourAction = true;
    },
    changeHue() {
      this.fourBtnShow = false;
      this.fourTitShow = true;
    },
    seeImg(item) {
      this.bigImgShow = true;
      this.bigImgUrl = item.imgUrl;
    },
  },
  watch: {
    landscapeType: function (newVal) {
      this.typePage = newVal;
    },
    newIndex: function (newValue) {
      if (newValue == "3") {
        this.pageFourAction = true;
      } else {
        this.pageFourAction = false;
      }
    },
  },
};
</script>
<style lang="less">
.fourPage {
  width: 100%;
  height: 100%;
  background-image: url("../../../../../public/img/dhShare/slideFour.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  position: relative;

  .fourIconPng {
    width: 100%;
    height: 100%;
    background-image: url("../../../../../public/img/dhShare/fourIcon.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    position: relative;
  }
  .fourIconPng.bgGray {
    -webkit-filter: grayscale(90%); /* Chrome, Safari, Opera */
    filter: grayscale(90%);
  }
   .titHeader {
    top: 66%;
    right: -10px;
    border: 1px solid #2a93ff;
    color: #2a93ff;
    .circle {
      border: 1px solid #2a93ff;
    }
  }
  .titBox {
    position: absolute;
    top: 150px;
    right: -50px;
    
    .textMian {
      width: 245px;
      font-size: 12px;
      margin-left: -10px;
      color: #2a93ff;
      transform: scale(0.9, 0.9);
      -webkit-transform: scale(0.9, 0.9);
      text-align: justify;
      opacity: 0;
      
    }
  }
   .fourAnimated {
    animation: bounceInUp 2s forwards linear;
    /* Safari 和 Chrome */
  }
  /** css3动画效果 **/
 
  .imgMainBox {
    position: absolute;
    bottom: 25px;
    left: 0;
    
    z-index: 999;
    width: 100%;
    display: none;
    .swiperChild.swiper-container {
      width: 320px;
      height: 120px;
      .swiper-wrapper {
        margin-top: 15px;
        .slideItem.swiper-slide {
          width: 110px;
          height: 95px;
          background-color: #fff;
          z-index: 1000;
          border-radius: 10px;
          -webkit-border-radius: 10px;
          padding: 5px 5px;
          opacity: 0.7;
          .van-image {
            width: 100%;
            height: 100%;
            border-radius: 8px;
            img {
              border-radius: 8px;
            }
          }
        }
        .slideItem.swiper-slide.swiper-slide-active {
          transform: scale(1.2);
          opacity: 1;
        }
      }
    }
  }
  .tkMain.van-overlay {
    position: absolute !important;
    width: 100% !important;
    height: 75% !important;
    left: 0;
    top: 0;
    z-index: 9999;
    background-color: rgba(225, 225, 225, 0);
    overflow: hidden;

    .wrapper {
      position: absolute;
      width: 320px;
      height: 450px;
      background-color: #fff;
      padding: 5px 5px;
      left: 50%;
      top: 50%;
      margin-left: -155px;
      margin-top: -210px;
      border-radius: 10px;
      -webkit-border-radius: 10px;
    }

    .van-image {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      img {
        border-radius: 8px;
      }
    }
  }
  .imgMainBox.imgMainBoxShow {
    display: block;
  }
}
</style>